<template>
  <v-app>
    <!-- SESSION EXPIRED OVERLAY -->
    <SessionExpiredOverlay
      v-if="$route.meta.requiresAuth"
    />

    <!-- APP BAR -->
    <v-app-bar color="primary" app>
      <!-- Logos -->
      <a target="_blank" href="https://www.unicamp.br" style="text-decoration: none">
        <img src="https://autenticacao.fe.unicamp.br/themes/custom/fe_theme/logo_unicamp.png"
             alt="Logo UNICAMP"
             style="height: 50px; margin-top: 15px; margin-left: 100px" />
      </a>

      <a target="_blank" href="https://www.fe.unicamp.br" style="text-decoration: none">
        <img src="https://autenticacao.fe.unicamp.br/themes/custom/fe_theme/logo.png"
             alt="Faculdade de Educação"
             style="height: 50px; margin-top: 15px; margin-left: 20px" />
      </a>

      <v-spacer></v-spacer>

      <!-- Desktop -->
      <div v-if="$vuetify.display.mdAndUp" style="display: flex; align-items: center; margin-right: 40px;">
        <template v-if="isAuthenticated">
          <v-menu activator="parent" color="secondary" rounded>
            <template #activator="{ props }">
              <v-btn 
                v-bind="props" 
                variant="outlined" 
                rounded 
                color="white" 
                style="display: flex; align-items: center; text-transform: none; font-weight: 500; white-space: nowrap;"
              >
                <v-icon left style="color: white; margin-right: 4px;">mdi-account</v-icon>
                {{ user.given_name }}
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <div class="mx-auto text-center">
                  <v-avatar color="primary">
                    <span class="text-h5">{{ userInitials }}</span>
                  </v-avatar>
                  <h3>{{ user.given_name + ' ' + user.family_name }}</h3>
                  <p class="text-caption mt-1">{{ user.email }}</p>
                  <v-divider class="my-3"></v-divider>
                  <v-btn variant="text" rounded :href="keycloakAccountUrl">
                    Alterar dados
                  </v-btn>
                  <v-btn variant="text" rounded @click="logout">Sair da sessão</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-menu>
        </template>
        <template v-else>
          <v-btn 
            variant="outlined" 
            rounded 
            color="white" 
            style="display: flex; align-items: center; text-transform: none; font-weight: 500;"
            @click="login"
          >
            <v-icon left style="color: white; margin-right: 4px;">mdi-account</v-icon>
            Login
          </v-btn>
        </template>
      </div>

      <!-- Mobile -->
      <div v-else style="margin-right: 10px;">
        <v-menu color="secondary" rounded offset-y>
          <template #activator="{ props }">
            <v-btn v-bind="props" icon>
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-text>
              <div v-if="isAuthenticated" class="text-center">
                <v-avatar color="primary" class="mb-2">
                  <span class="text-h5">{{ userInitials }}</span>
                </v-avatar>
                <h3>{{ user.given_name + ' ' + user.family_name }}</h3>
                <p class="text-caption mt-1">{{ user.email }}</p>
                <v-divider class="my-2"></v-divider>
                <v-btn variant="text" rounded block :href="keycloakAccountUrl">
                  Alterar dados
                </v-btn>
                <v-btn variant="text" rounded block @click="logout">
                  Sair da sessão
                </v-btn>
              </div>
              <div v-else class="text-center">
                <v-btn variant="text" rounded block @click="login">
                  Login
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </v-app-bar>

    <!-- FOOTER -->
    <v-footer dense color="primary" app>
      <p class="text-center w-100">
        © {{ new Date().getFullYear() }} - Faculdade de Educação - UNICAMP - todos os direitos reservados
      </p>
    </v-footer>

    <!-- MAIN -->
    <v-main class="custom-main">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import keycloak from './plugins/keycloak';
import SessionExpiredOverlay from './components/SessionExpiredOverlay.vue';

export default {
  name: 'App',
  components: { SessionExpiredOverlay },
  computed: {
    user() {
      return this.$store.getters.getUserData;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    userInitials() {
      if (!this.user) return '';
      const first = this.user.given_name ? this.user.given_name[0] : '';
      const last = this.user.family_name ? this.user.family_name[0] : '';
      return first + last;
    },
    keycloakAccountUrl() {
      const host = this.$KCURL;
      const myFinalHost = encodeURIComponent(`${this.$FRONTPATH}/form?update=true`);
      const realm = this.$KCREALM;
      const clientId = this.$KCCLIENTID;
      const myUrl = `${host}/realms/${realm}/protocol/openid-connect/auth` +
        `?client_id=${clientId}` +
        `&redirect_uri=${myFinalHost}` +
        `&response_type=code` +
        `&scope=openid` +
        `&kc_action=UPDATE_PROFILE` +
        `&prompt=login`;
      return myUrl;
    },
  },
  async mounted() {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  methods: {
    login() {
      keycloak.login({redirectUri: `${this.$FRONTPATH}`});
    },
    logout() {
      keycloak.logout({ redirectUri: window.location.origin + '/' });
      this.$store.commit('setIsAuthenticated', false);
      this.$store.commit('setUserData', { given_name: '', family_name: '', email: '', kc_uuid:'' });
      this.$store.commit('setToken', '');
    },
  },
};
</script>

<style>
.custom-main {
  background-color: #f5f5f5;
}
</style>
